(function($){

/* from anchormenu.js */
if ($('.anchor-menu').length) {
    $(window).scroll(function () {
        var scrollDistance = $(window).scrollTop();
        var menuHeight = $('.anchor-menu').outerHeight();

        $('.et_pb_section, .et_pb_row_inner, .et_pb_row').each(function () {
            var sectionId = $(this).attr('id');
            if (scrollDistance > $(this).offset().top - menuHeight && scrollDistance < $(this).offset().top + $(this).outerHeight() - menuHeight) {
                $('.anchor-menu li a[href*="#' + sectionId + '"]').parent().addClass('active');





                //slick go to
                if ($('.anchor-menu-item li:not(.slick-cloned) a[href*="#' + sectionId + '"]').length) {
                    var relatedTab = $('.anchor-menu-item li:not(.slick-cloned) a[href*="#' + sectionId + '"]').parent().attr('data-num');
                    $('.anchor-menu-item.slick-slider').slick('slickGoTo', relatedTab);
                } else {
                    var activePage = 0;
                    $('.anchor-menu-item.slick-slider').slick('slickGoTo', activePage);
                }
            } else {
                $('.anchor-menu li a[href*="#' + sectionId + '"]').parent().removeClass('active');
            }
        });
    });

    $(document).scroll(function () {
        stickyAnchorSubFunction();
    });

    $(window).resize(function () {
        anchorSlick();
    });

    stickyAnchorSubFunction();
    anchor2Link();
    anchorSlick();
}
/* from anchormenu.js */



/* from anchormenu.js */
function stickyAnchorSubFunction() {
    var top = $('.anchor-menu').offset().top;
    var scrollTop = $(window).scrollTop();
    var baseTop = $('.anchor-menu-top').offset().top;

    if (scrollTop >= top) {
        $('.anchor-menu').addClass('sticky');
        $('.anchor-menu-top').css('height', $('.anchor-menu').outerHeight() + 'px');
    }

    if (top < baseTop) {
        $('.anchor-menu').removeClass('sticky');
        $('.anchor-menu-top').css('height', 0);
    }
}

function anchor2Link() {
    $('.anchor-menu li a[href*="#"]').click(function (event) {

        var url = $(this).attr("href");
        var hrefTarget = $(this).attr('href');

        var scrollDistance = $(window).scrollTop();
        var menuHeight = $('.anchor-menu').outerHeight() - 1;


        if ($(this).is('[href*="#product-tab"]')) {
            $('.tab-title').removeClass('active-tab');
            $('.tab-title[data-url="' + hrefTarget + '"]').addClass('active-tab');
            $("[id^='product-tab-'], [id*='product-tab-']").removeClass('open');
            $(hrefTarget).addClass('open');
        }

        $('html, body').animate({
            scrollTop: (($(hrefTarget).offset().top) - menuHeight)
        }, 500);

        event.preventDefault();
    });
}

function anchorSlick() {
    //Detecte si le nombre de tab dépasse la taille total du menu
    var totalWidth = 0;
    $('.anchor-menu-item').find('li:not(.slick-cloned)').each(function () {
        totalWidth += parseInt($(this).outerWidth(true), 10);
    });
    var containerWidth = $('.anchor-menu-item').outerWidth();

    var i = 0;

    $('.anchor-menu-item li:not(.slick-cloned)').each(function () {
        $(this).attr("data-num", i);
        i++;
    });

    if (containerWidth > totalWidth) {
        var slideToshow = 99;
        $('.anchor-menu-item.slick-slider').slick('unslick');
    } else {
        var slideToshow = 1;
        /*if ($('.anchor-menu-item li.active').length) {
            var slideActive = $('.anchor-menu-item li.active:not(.slick-cloned)').attr("data-num");
            var slideActiveInt = parseInt(slideActive);
        } else {
            var slideActiveInt = 0;
        }*/

        $('.anchor-menu-item').slick({
            //initialSlide: slideActiveInt,
            slidesToShow: slideToshow,
            focusOnSelect: true,
            arrows: false,
            speed: 500,
            variableWidth: true,
            dots: false,
        });

    }
}
/* from anchormenu.js */

})(jQuery);